import * as React from 'react'

interface ISkipTooltipTimerIconProps {
  height?: number
  width?: number
}

const SkipTooltipTimerIcon = ({ width = 16, height = 16, ...props }: ISkipTooltipTimerIconProps) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#clip0_13_3858)">
      <path
        d="M8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 8.00004C14.6668 4.31814 11.6821 1.33337 8.00016 1.33337C4.31826 1.33337 1.3335 4.31814 1.3335 8.00004C1.3335 11.6819 4.31826 14.6667 8.00016 14.6667Z"
        stroke="white"
        strokeWidth={1.20294}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7.99963 4V8L10.6663 9.33333" stroke="white" strokeWidth={1.20294} strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_13_3858">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SkipTooltipTimerIcon;